import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { forwardRef } from 'react';
import { classnames } from '@@client/lib/classes';
import SectionHeader from './SectionHeader';
var GatherSection = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$isIncluded = _ref.isIncluded,
      isIncluded = _ref$isIncluded === void 0 ? false : _ref$isIncluded,
      _ref$isAvailable = _ref.isAvailable,
      isAvailable = _ref$isAvailable === void 0 ? false : _ref$isAvailable,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$number = _ref.number,
      number = _ref$number === void 0 ? null : _ref$number,
      title = _ref.title,
      children = _ref.children,
      _ref$showEdit = _ref.showEdit,
      showEdit = _ref$showEdit === void 0 ? false : _ref$showEdit,
      _ref$onEditClick = _ref.onEditClick,
      onEditClick = _ref$onEditClick === void 0 ? function () {} : _ref$onEditClick,
      _ref$editTitle = _ref.editTitle,
      editTitle = _ref$editTitle === void 0 ? null : _ref$editTitle;
  if (!isIncluded) return null;
  var containerClassName = classnames(['container', isAvailable ? 'is-available' : 'not-available', isOpen ? 'is-open' : 'not-open']);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      ref: ref,
      className: "jsx-603162241" + " " + (containerClassName || ""),
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        disabled: !isAvailable,
        isOpen: isOpen,
        number: number,
        showEdit: showEdit,
        onEditClick: onEditClick,
        editTitle: editTitle,
        children: title
      }), /*#__PURE__*/_jsx("div", {
        className: "jsx-603162241" + " " + 'inner',
        children: isOpen && isAvailable ? children : null
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "603162241",
      children: [".container.jsx-603162241{border-radius:6px;background:white;padding:18px;border:1px solid #6BA8FF;margin-bottom:30px;}", ".container.not-available.jsx-603162241{background:#F7F8FA;border-color:#DDE0DA;}", ".inner.jsx-603162241{padding:0 7px;}", "@media(min-width:576px){.inner.jsx-603162241{padding:0 15px;}}", ".not-open.jsx-603162241 .inner.jsx-603162241,.not-available.jsx-603162241 .inner.jsx-603162241{display:none;}"]
    })]
  });
});
export default GatherSection;